export const TEXT_INPUT_STYLE = {
    paddingLeft: 10
};

export const SUCCESS_MESSAGE = "Ваш запрос успешно отправлен";
export const ERROR_MESSAGE = "Произошла ошибка. Попробуйте позже";

export interface ContactsPageProps {
    title?: string;
    showCompanyCard?: boolean;
}